/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsUserTrialListItem
 */
export interface MelcoModelsUserTrialListItem {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserTrialListItem
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserTrialListItem
     */
    product_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserTrialListItem
     */
    product_version_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserTrialListItem
     */
    product_version_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserTrialListItem
     */
    product_level_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserTrialListItem
     */
    product_level_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserTrialListItem
     */
    product_level_name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsUserTrialListItem
     */
    start_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsUserTrialListItem
     */
    end_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsUserTrialListItem
     */
    updated_date?: Date | null;
}

export function MelcoModelsUserTrialListItemFromJSON(json: any): MelcoModelsUserTrialListItem {
    return MelcoModelsUserTrialListItemFromJSONTyped(json, false);
}

export function MelcoModelsUserTrialListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsUserTrialListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'product_name': !exists(json, 'product_name') ? undefined : json['product_name'],
        'product_version_id': !exists(json, 'product_version_id') ? undefined : json['product_version_id'],
        'product_version_number': !exists(json, 'product_version_number') ? undefined : json['product_version_number'],
        'product_level_id': !exists(json, 'product_level_id') ? undefined : json['product_level_id'],
        'product_level_code': !exists(json, 'product_level_code') ? undefined : json['product_level_code'],
        'product_level_name': !exists(json, 'product_level_name') ? undefined : json['product_level_name'],
        'start_date': !exists(json, 'start_date') ? undefined : (new Date(json['start_date'])),
        'end_date': !exists(json, 'end_date') ? undefined : (new Date(json['end_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
    };
}

export function MelcoModelsUserTrialListItemToJSON(value?: MelcoModelsUserTrialListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_code': value.product_code,
        'product_name': value.product_name,
        'product_version_id': value.product_version_id,
        'product_version_number': value.product_version_number,
        'product_level_id': value.product_level_id,
        'product_level_code': value.product_level_code,
        'product_level_name': value.product_level_name,
        'start_date': value.start_date === undefined ? undefined : (value.start_date.toISOString()),
        'end_date': value.end_date === undefined ? undefined : (value.end_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
    };
}


